import type { DotToUnderscore } from '@dresscode-frontend/utility-types';
import type { ColumnDef } from '@tanstack/table-core';

import { simpleTextColumn } from '@/components/DataTable/Columns/simpleTextColumn';
import { AppUserColumn } from '@/features/app-user/components/AppUserColumn';
import { PersonColumn } from '@/features/app-user/components/PersonColumn';

import type { AlertRowWithWorker } from '../../-shared/types';
import { ActionsColumn } from '../../../-components/actions-column';
import { AppUserPrimaryActionColumn } from '../../../-components/app-usr-primary-action-column';
import IntegratedAppColumn from '../../../-components/integrated-app-column';

type Row = AlertRowWithWorker;

export const ColumnKey = {
  appUser: 'user',
  worker: 'worker',
  app: 'software',
  correctRole: 'worker.assignedRoleName',
} as const;

export const SortableColumnKey = [
  ColumnKey.appUser,
  ColumnKey.worker,
  ColumnKey.app,
  'worker_assignedRoleName',
] as const satisfies DotToUnderscore<
  (typeof ColumnKey)[keyof typeof ColumnKey]
>[];

export function useSoftwareAlertsNoUserColumns(): ColumnDef<Row>[] {
  return [
    // どうせないので表示しない
    AppUserColumn({
      i18nKey: 'appUser',
      minWidth: '360px',
      maxWidth: '400px',
    }),
    PersonColumn(ColumnKey.worker, {
      i18nKey: 'person',
      minWidth: '360px',
      maxWidth: '400px',
    }),
    IntegratedAppColumn(ColumnKey.app, {}),
    simpleTextColumn(ColumnKey.correctRole, {
      i18nKey: 'correctRole',
      sortable: true,
    }),
    AppUserPrimaryActionColumn(),
    ActionsColumn(),
  ];
}
